var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudMigration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 0 50 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 46.875C12.6605 46.875 13.5 46.0355 13.5 45C13.5 43.9645 12.6605 43.125 11.625 43.125C10.5895 43.125 9.75 43.9645 9.75 45C9.75 46.0355 10.5895 46.875 11.625 46.875Z",
    fill: "#848484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 37.5H34.125V41.25H43.5V48.75H6V41.25H22.875C24.9375 41.25 26.625 39.5625 26.625 37.5V20.3062L31.4813 25.1625L34.125 22.5L24.75 13.125L15.375 22.5L18.0187 25.1437L22.875 20.3062V37.5H6C3.9375 37.5 2.25 39.1875 2.25 41.25V48.75C2.25 50.8125 3.9375 52.5 6 52.5H43.5C45.5625 52.5 47.25 50.8125 47.25 48.75V41.25C47.25 39.1875 45.5625 37.5 43.5 37.5Z",
    fill: "#848484"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2812 11.3438C37.6313 4.78125 31.6313 0 24.75 0C17.8687 0 11.8687 4.78125 10.2188 11.3438C4.66875 12.0375 0.375 16.7813 0.375 22.5C0.375 28.7062 5.41875 33.75 11.625 33.75H15.375V30H11.625C7.48125 30 4.125 26.6438 4.125 22.5C4.125 18.3937 7.44375 15.0562 11.5312 15L13.3875 15.0375L13.6125 13.3875C14.4188 7.89375 19.2 3.75 24.75 3.75C30.3 3.75 35.0813 7.89375 35.8688 13.4062L36.0937 15.0562L37.7438 15.0188L37.9875 15C39.9571 15.0295 41.8359 15.8327 43.2182 17.2361C44.6005 18.6394 45.3752 20.5302 45.375 22.5C45.375 26.6438 42.0188 30 37.875 30H34.125V33.75H37.875C44.0812 33.75 49.125 28.7062 49.125 22.5C49.125 16.7813 44.8313 12.0375 39.2812 11.3438Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudMigration);
export default __webpack_public_path__ + "static/media/cloud-migration.8f29554e293170f740928b3ba9bd21bd.svg";
export { ForwardRef as ReactComponent };